import { useParams } from 'react-router-dom';
import { Notification } from 'components/Notification';
import { ContentWrapper } from 'components/layout';
import { useAnswer, useUpdateAnswer } from 'api/answerApi';
import { AnswerForm } from './components';
import { useIntl } from 'react-intl';
import { Loading } from 'components/loading';

function normalizeData(data) {
  if (!data) {
    return null;
  }

  const { content, locale, order } = data;

  return {
    content,
    order,
    locale: locale?.code,
  };
}

export default function ViewAnswer() {
  const intl = useIntl();
  const { id } = useParams();
  const { data, isLoading, isFetching } = useAnswer({
    id,
  });
  const updateMutation = useUpdateAnswer(id);

  const handleSubmit = (values) => {
    updateMutation.mutate(values, {
      onSuccess() {
        Notification(
          'success',
          intl.formatMessage({
            id: `message.updateSuccess`,
          }),
        );
      },
      onError(error) {
        Notification(
          'error',
          error.message ?? intl.formatMessage({ id: 'message.commonError' }),
        );
      },
    });
  };

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (!data) {
    return null;
  }

  return (
    <ContentWrapper title="Chỉnh sửa">
      <AnswerForm
        onSubmit={handleSubmit}
        isLoading={updateMutation.isLoading}
        initialValues={normalizeData(data)}
        relatedEntityId={data.id}
        localizations={data.localizations}
      />
    </ContentWrapper>
  );
}
